/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useCallback } from "react";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import PropTypes from "prop-types";
import { Button, FormGroup, Input, Label } from "reactstrap";
import RequiredField from "../../helpers/requiredField";
import ExpirationFields from "./expirationFields";

const CardStep = ({
  card,
  cardName,
  cardNumber,
  cardSecurity,
  expiration,
  handleCCFormatting,
  handleCardName,
  handleCardSecurity,
  handleStepCard,
  setCard,
  valid,
  validName,
  validNumber,
  validSecurity
}) => {
  const [checked, setCheck] = useState(true);

  const toggleHidden = useCallback(() => {
    const el = document.getElementsByClassName("rccs__number")[0]; // grab cc number from visual cc element

    // must be id, library removes classList
    if (checked) {
      el.setAttribute("id", "hidden-cc");
    } else {
      el.removeAttribute("id", "hidden-cc");
    }
  }, [checked]);

  const handleChange = () => {
    setCheck(!checked);
  };

  useEffect(() => {
    toggleHidden();
  }, [toggleHidden]);

  return (
    <div className="checkout__step-body">
      <div className="row">
        <div className="col-sm">
          <Cards
            number={card.number}
            focused={card.focus}
            name={card.name}
            expiry={card.expiration}
            cvc={card.security}
            preview
          />
        </div>
        <div className="col-sm">
          <Label>
            <Input
              type="checkbox"
              checked={checked}
              onChange={e => handleChange(e)}
              className="me-2 mb-0"
            />
            Mask Credit Card Information
          </Label>
          <FormGroup>
            <div className={`input-group ${!validNumber ? "is-invalid" : ""}`}>
              <Input
                aria-label="input credit card number"
                id="cardNumber"
                type="text"
                required
                value={cardNumber || ""}
                onChange={e => {
                  handleCCFormatting(e);
                }}
                onFocus={e => setCard({ ...card, focus: e.target.name })}
                className={!validNumber ? "is-invalid" : ""}
                data-private="redact"
                placeholder="Credit Card Number"
              />
            </div>
            <RequiredField />
          </FormGroup>
          <FormGroup>
            <Input
              id="ccName"
              type="text"
              required
              defaultValue={cardName}
              onChange={e => handleCardName(e)}
              onFocus={e => setCard({ ...card, focus: e.target.name })}
              invalid={!validName}
              data-private="redact"
              placeholder="Full Name"
            />
            <RequiredField />
          </FormGroup>
          <div className="expiration-security-container">
            <div id="expiration-form-container">
              <div className="expiration-form-container">
                <ExpirationFields
                  id="expiration-fields"
                  card={card}
                  setCard={setCard}
                  data-private="redact"
                  valid={valid}
                  invalid={expiration === false}
                  placeholder="Expiration Date (MM/YY)"
                />
              </div>
              {expiration === false && (
                <div id="expiration-feedback">
                  Please enter a valid expiration date.
                </div>
              )}
            </div>
            <div id="ccv-container">
              <FormGroup>
                <Input
                  aria-label="input security code"
                  name="cvc"
                  id="securityCode"
                  type="text"
                  pattern="\d*"
                  maxLength="4"
                  required
                  value={cardSecurity}
                  onChange={e => handleCardSecurity(e)}
                  onFocus={e => setCard({ ...card, focus: e.target.name })}
                  invalid={!validSecurity}
                  data-private="redact"
                  placeholder="CVC"
                />
                <RequiredField errorText="Please enter a vaild security code." />
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
      <div className="checkout__step-continue">
        <Button
          block
          color="primary"
          id="cardStep_saveAndContinue"
          onClick={handleStepCard}
        >
          Save and Continue
        </Button>
      </div>
    </div>
  );
};

CardStep.propTypes = {
  card: PropTypes.object.isRequired,
  cardName: PropTypes.string,
  cardNumber: PropTypes.string,
  cardSecurity: PropTypes.string.isRequired,
  expiration: PropTypes.bool,
  handleCCFormatting: PropTypes.func.isRequired,
  handleCardName: PropTypes.func.isRequired,
  handleCardSecurity: PropTypes.func.isRequired,
  handleStepCard: PropTypes.func.isRequired,
  setCard: PropTypes.func.isRequired,
  valid: PropTypes.object,
  validName: PropTypes.bool.isRequired,
  validNumber: PropTypes.bool.isRequired,
  validSecurity: PropTypes.bool.isRequired
};

CardStep.defaultProps = {
  cardNumber: undefined,
  cardName: undefined,
  expiration: undefined,
  valid: undefined
};

export default CardStep;
